import type { PrivateEvent } from '../../api/privateEvents';

import { incompleteListFields } from './privateEventDisplay';

/**
 * The list's completeness marker: how many of location, crew and contact an
 * event is missing. Imported events say so, because their gaps come from
 * FareHarbor rather than from anyone in Nebari. Renders nothing when complete.
 */
export default function IncompleteMarker({ event }: { event: PrivateEvent }) {
  const missing = incompleteListFields(event);
  if (missing.length === 0) return null;
  const source = event.migrated ? ' (not present in the FareHarbor source)' : '';
  return (
    <span
      title={`Missing: ${missing.join(', ')}${source}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 20,
        padding: '0 8px',
        borderRadius: 999,
        border: '1px dashed var(--nb-border-2)',
        color: 'var(--nb-subtle)',
        fontSize: 10.5,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {event.migrated ? 'Incomplete import' : 'Incomplete'} · {missing.length}
    </span>
  );
}
